module.exports = __webpack_public_path__ + "static/media/birdie.08532b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/birdie.png
// module id = 5766
// module chunks = 0